// extracted by mini-css-extract-plugin
export default {"container":"Authentication_container__wxThk"};